/**
 * VendorResponseService
 * Service for managing vendor responses to ratings
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for vendor response CRUD operations
 */
export class VendorResponseService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? VendorResponseService.DEFAULT_SERVICE_PATH,
            basePath: VendorResponseService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
VendorResponseService.DEFAULT_SERVICE_PATH = 'vendor-ratings';
VendorResponseService.BASE_PATH = 'api/vendor-responses';
//# sourceMappingURL=VendorResponseService.js.map